// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{box-sizing:border-box}body,html{margin:0;padding:0;background:#0e1720;color:#e8f1f8;font-family:Inter,Segoe UI,system-ui,sans-serif}button{font-family:inherit}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
